import { makeStyles } from '@material-ui/core'

const styles = (color, isOngoing = false) =>
  makeStyles((theme) => ({
    paper: {
      backgroundColor: theme.palette.background.default,
      paddingInline: theme.spacing(2),
      paddingBlock: theme.spacing(2),
      ...(isOngoing && { border: `2px solid ${color}` }),
      display: 'flex',
      gridGap: theme.spacing(3),
      justifyContent: 'space-between',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        alignItems: 'center',
      },
    },
    comumContainer: {
      display: 'flex',
      gridGap: theme.spacing(3),
      alignItems: 'center',
    },
    categoryIcon: {
      padding: 4,
    },
    containerIcon: {
      color: theme.palette.common.white,
      backgroundColor: color,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
    },
  }))

export default styles
